import { TimeInvariantBase } from '../TimeInvariantBase';
import { NumberAttribute, getAttributesToSerialize } from '../attributes';
import { observable } from '../reactivity';

/**
 * Contains watermark margins & max size for one aspect ratio
 */
export class WatermarkLayout extends TimeInvariantBase {
    override _classType = 'WatermarkLayout';
    override name = 'WatermarkLayout';

    @NumberAttribute()
    @observable
    accessor marginLeft = 0;
    @NumberAttribute()
    @observable
    accessor marginTop = 0;
    @NumberAttribute()
    @observable
    accessor marginRight = 0;
    @NumberAttribute()
    @observable
    accessor marginBottom = 0;
    @NumberAttribute()
    @observable
    accessor maxWidth = 0;
    @NumberAttribute()
    @observable
    accessor maxHeight = 0;

    override get propertiesToSerialize(): Array<string> {
        return getAttributesToSerialize(this);
    }
}
